import type { AwsIntegration } from "@p0security/integrations-aws-shared/types";
import { SINGLETON_ITEM } from "@p0security/shared/install/constants";
import { assertNever } from "@p0security/shared/types/index";
import { Typography } from "@p0security/ui";
import type { Dictionary } from "lodash";

import { postgresLegacyInstallTypeInstaller } from "./installType";
import { awsRdsInstructor } from "./instructions/aws-rds";
import { gcpCloudSqlInstructor } from "./instructions/gcp-cloudsql";
import type { PostgresLegacyInstaller } from "./types";

const PostgresLegacyPreamble = (
  <>
    <Typography.Paragraph>
      Enable secure, granular access control for PostgreSQL databases on Google
      Cloud SQL and Amazon RDS with automated provisioning and audit logging.
    </Typography.Paragraph>
    <Typography.Text strong>Prerequisites:</Typography.Text>
    <ul className="preamble-list">
      <li>
        A fully managed PostgreSQL database on Google Cloud SQL or Amazon RDS
      </li>
    </ul>
  </>
);

export const postgresLegacyInstaller: PostgresLegacyInstaller = {
  components: {
    "access-management": {
      labeler: () => (
        <>
          Please enter a unique label which will only be used to identify this
          database in the P0 interface. You will be prompted for the database
          name and other details in the following steps. You cannot change this
          later.
        </>
      ),
      instructions: (context, _id, item) => {
        switch (item.installType.type) {
          case "cloud-sql": {
            const gcp = context.installed.gcloud;
            const config: Dictionary<string> | undefined =
              gcp?.root?.[SINGLETON_ITEM];
            const gcpServiceAcctEmail = config?.serviceAccountEmail;
            return gcpServiceAcctEmail
              ? gcpCloudSqlInstructor(item, gcpServiceAcctEmail)
              : {};
          }
          case "rds": {
            // Intentional cast here; we could replace with schema validation later
            const aws = context.installed.aws as AwsIntegration | undefined;
            return aws ? awsRdsInstructor(aws, context, item) : {};
          }
          default:
            return assertNever(item.installType);
        }
      },
      items: {
        installType: postgresLegacyInstallTypeInstaller,
      },
    },
  },
  preamble: PostgresLegacyPreamble,
};
